import _ from 'lodash'
import './workstationSelect.scss'
import templateUrl from './workstationSelect.html'

/**
 * Workstation select component.
 *
 * Allows the user to change the active workstation.
 *
 * @example
 * <tmr-workstation-select></tmr-workstation-select>
 *
 * @type {ngComponent}
 */
export const tmrWorkstationSelect = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrWorkstationSelectController',
}

/**
 * Controller of component {@link tmrWorkstationSelect}.
 *
 * @type {ngController}
 */
export class tmrWorkstationSelectController {
  static ngType = 'controller'

  constructor(
    $rootScope,
    $stateParams,
    TmrLocalStorage,
    TmrToast,
    Workstation,
    ActiveWorkstation
  ) {
    'ngInject'
    Object.assign(this, {
      $rootScope,
      $stateParams,
      TmrLocalStorage,
      TmrToast,
      Workstation,
      ActiveWorkstation,
    })
  }

  $onInit() {
    // Set active workstation to default value, so it is shown without the need to
    // load all workstations.
    this.workstations = []
    this.ActiveWorkstation.get().$promise.then(workstation => {
      if (workstation.id && !this.workstation) {
        this.workstation = workstation
        this.workstations.push(workstation)
      }
      this.onWorkstationSetDeregister = this.$rootScope.$on(
        'activeworkstationset',
        (event, workstation, first) => this.onWorkstationSet(workstation, first)
      )
    })
  }

  /** Loads workstations */
  onSelectOpen() {
    this.loading = true
    this.workstations.length = 0
    return this.Workstation.getByLoggedUser()
      .$promise.then(workstations => this.workstations.push(...workstations))
      .catch(err => this.TmrToast.exception(err))
      .finally(() => (this.loading = false))
  }

  /** Updates active workstation. */
  onWorkstationChange(workstation) {
    this.ActiveWorkstation.set(workstation, this.$stateParams.transitionState)
  }

  /** Workstation set event callback */
  onWorkstationSet(workstation, first) {
    if (!first)
      this.TmrToast.success('WORKSTATIONSELECT.CHANGED', {
        workstation: workstation.$getLabel(),
      })
    this.onWorkstationSetDeregister()
  }

  /** Returns true if the sidebar is expanded */
  isExpanded() {
    return this.TmrLocalStorage.get('sidebarExpanded', true)
  }

  /**
   * The md-select directive eats keydown events for some quick select
   * logic. Since we have a search input here, we don't need that logic.
   * @see https://github.com/angular/material/issues/9321
   */
  onSearchKeyDown($event) {
    $event.stopPropagation()
  }

  /** Callback for workstations filter */
  filterWorkstations() {
    return ({ id, description }) =>
      id === this.workstation?.id ||
      !this.workstationSearch ||
      !description ||
      _.iIncludes(description, this.workstationSearch)
  }
}
